import { Fragment, useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from 'model/Auth';
import { useDataContext } from 'context/DataStoreContext';
import Login from 'component/page/Login';
import Home from 'component/page/Home';
import LedgerList from 'component/page/ledger/List';
import LedgerShow from 'component/page/ledger/Show';
import LedgerEdit from 'component/page/ledger/Edit';
import ScheduleList from 'component/page/schedule/List';
import ArrangementSetup from 'component/page/arrangement/Setup';
import ReportList from 'component/page/report/List';
import ReportShow from 'component/page/report/Show';
import ReportEdit from 'component/page/report/Edit';
import MemberList from 'component/page/member/List';
import MemberShow from 'component/page/member/Show';
import MemberEdit from 'component/page/member/Edit';
import PartnerList from 'component/page/partner/List';
import PartnerShow from 'component/page/partner/Show';
import PartnerEdit from 'component/page/partner/Edit';
import ContractorList from 'component/page/contractor/List';
import ContractorShow from 'component/page/contractor/Show';
import ContractorEdit from 'component/page/contractor/Edit';
import WorkProcessList from 'component/page/workProcess/List';
import WorkProcessEdit from 'component/page/workProcess/Edit';
import WorkResourceList from 'component/page/workResource/List';
import WorkResourceEdit from 'component/page/workResource/Edit';
import LineRelationList from 'component/page/lineRelation/List';
import LineRelationEdit from 'component/page/lineRelation/Edit';
import LineRelationSet from 'component/page/lineRelation/Set';
import LineRelationCode from 'component/page/lineRelation/Code';
import RoleList from 'component/page/role/List';
import RoleEdit from 'component/page/role/Edit';
import MypagePasswordEdit from 'component/page/mypage/PasswordEdit';

const AuthRouter: React.FC = () => {
  const { dispatch } = useDataContext();
  const auth = useAuth();
  const location = useLocation();
  const { user, status } = auth;

  useEffect(() => {
    (async () => {
      await auth.reference();
    })();
  }, [user, status, location.pathname, dispatch]);

  return <Routes>
    {user ? (
      <Fragment>
        <Route key='ledgerListWithDate' path='/ledger/list/:date' element={ <LedgerList /> } />
        <Route key='ledgerList' path='/ledger/list' element={ <LedgerList /> } />
        <Route key='ledgerShow' path='/ledger/:id' element={ <LedgerShow /> } />
        <Route key='ledgerShow' path='/ledger/:id/edit' element={ <LedgerEdit /> } />
        <Route key='ledgerCreate' path='/ledger/create' element={ <LedgerEdit /> } />
        <Route key='scheduleList' path='/schedule/list' element={ <ScheduleList /> } />
        <Route key='arrangementWithDate' path='/arrangement/:id/:date' element={ <ArrangementSetup /> } />
        <Route key='arrangement' path='/arrangement/:id' element={ <ArrangementSetup /> } />
        <Route key='reportList' path='/report/list' element={ <ReportList /> } />
        <Route key='reportShow' path='/report/:id' element={ <ReportShow /> } />
        <Route key='reportCreate' path='/report/:date/create' element={ <ReportEdit /> } />
        <Route key='reportEdit' path='/report/:date/:id/edit' element={ <ReportEdit /> } />
        <Route key='memberList' path='/member/list' element={ <MemberList /> } />
        <Route key='memberShow' path='/member/:id' element={ <MemberShow /> } />
        <Route key='MemberCreate' path='/member/create' element={ <MemberEdit /> } />
        <Route key='MemberEdit' path='/member/:id/edit' element={ <MemberEdit /> } />
        <Route key='PartnerList' path='/partner/list' element={ <PartnerList /> } />
        <Route key='PartnerShow' path='/partner/:id' element={ <PartnerShow /> } />
        <Route key='PartnerCreate' path='/partner/create' element={ <PartnerEdit /> } />
        <Route key='PartnerEdit' path='/partner/:id/edit' element={ <PartnerEdit /> } />
        <Route key='ContractorList' path='/contractor/list' element={ <ContractorList /> } />
        <Route key='ContractorShow' path='/contractor/:id' element={ <ContractorShow /> } />
        <Route key='ContractorCreate' path='/contractor/create' element={ <ContractorEdit /> } />
        <Route key='ContractorEdit' path='/contractor/:id/edit' element={ <ContractorEdit /> } />
        <Route key='WorkProcessList' path='/work-process/list' element={ <WorkProcessList /> } />
        <Route key='WorkProcessEdit' path='/work-process/edit' element={ <WorkProcessEdit /> } />
        <Route key='WorkResourceList' path='/work-resource/list' element={ <WorkResourceList /> } />
        <Route key='WorkResourceEdit' path='/work-resource/edit' element={ <WorkResourceEdit /> } />
        <Route key='MachineryList' path='/machinery/list' element={ <WorkResourceList /> } />
        <Route key='MachineryEdit' path='/machinery/edit' element={ <WorkResourceEdit /> } />
        <Route key='AttList' path='/att/list' element={ <WorkResourceList /> } />
        <Route key='AttEdit' path='/att/edit' element={ <WorkResourceEdit /> } />
        <Route key='CarList' path='/car/list' element={ <WorkResourceList /> } />
        <Route key='CarEdit' path='/car/edit' element={ <WorkResourceEdit /> } />
        <Route key='IndustrialWasteList' path='/industrial-waste/list' element={ <WorkResourceList /> } />
        <Route key='IndustrialWasteEdit' path='/industrial-waste/edit' element={ <WorkResourceEdit /> } />
        <Route key='LineRelationList' path='/line-relation/list' element={ <LineRelationList /> } />
        <Route key='LineRelationSet' path='/line-relation/set' element={ <LineRelationSet /> } />
        <Route key='LineRelationEdit' path='/line-relation/:id' element={ <LineRelationEdit /> } />
        <Route key='LineRelationCode' path='/line-relation/code' element={ <LineRelationCode /> } />
        <Route key='RoleList' path='/role/list' element={ <RoleList /> } />
        <Route key='RoleCreate' path='/role/create' element={ <RoleEdit /> } />
        <Route key='RoleEdit' path='/role/:id/edit' element={ <RoleEdit /> } />
        <Route key='MypagePasswordEdit' path='/mypage/password' element={ <MypagePasswordEdit /> } />
        <Route path='/*' element={
          user.role?.permissions.ledgerEdit
            ? <LedgerList /> :
          user.role?.permissions.reportCreate
            ? <ReportList /> :
          user.role?.permissions.userEdit
            ? <MemberList />
            : <Home />
        } />
      </Fragment>
    ) : (
      <Fragment>
        <Route key='login' path='/login' element={ <Login /> } />
        <Route path='/*' element={
          status === 'logouted'
            ? <Navigate to='/login' state={{ redirectPath: location.pathname }} />
            : <Login />
        } />
      </Fragment>
    )}
  </Routes>
};

export default AuthRouter;
